module.exports = __webpack_public_path__ + "static/media/cross-icon.2d0251cb.svg";